module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center01"
  }, [_c('strong', [_vm._v("POUR ELIZABETH « BOOM-BOOM » EULBERG"), _c('br'), _vm._v("VIVE LE E.E.C.!")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "center00"
  }, [_c('strong', [_vm._v("Avis aux parents et enseignants")])]), _vm._v(" "), _c('p', {
    staticClass: "center00"
  }, [_vm._v("Les fôtes d’ortograf"), _c('br'), _vm._v("dent les BD de Georges et Harold"), _c('br'), _vm._v("son vous lues.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c9b7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 60
// module chunks = 0